import React from 'react';

export default function NewBookingsItem({ client, fullbookdate, hour, date, day, item, month, paid, service, status, time, total, year, }) {

    const mensajeDom = `hola ${client.name}! soy Valu de la Coquetería. el día ${day}/${month} a las ${time} tenemos turno en tu espacio.\n\n ✂ Me repetirías tu dirección así me queda por este medio? \n ✂ por favor, esperame con el pelo limpio o sin productos de finalizar (cremas o geles)\n ✂ siempre trato de ser puntual, pero por cuestiones de traslado entre casa y casa, el margen de demora puede ser de hasta 10 minutos  \n ✂ en caso de que necesites cancelar, avisando con más de 24 horas se reprograma o devuelve la seña. con menos tiempo, se pierde la seña y la posibilidad de programar nuevamente el turno.\n\n Muchas gracias y te veo en tu espacio :)`;
    const baseUrl = "https://api.whatsapp.com/send/?phone=";
    const phoneNumber =  client !== null ? client.phone : null; 
    const encodedMessageDom = encodeURIComponent(mensajeDom);
    const fullUrlDom = `${baseUrl}${phoneNumber}&text=${encodedMessageDom}`;
    
    const mensajeLocal=  client !== null ? `hola ${client.name}! soy Valu de la Coquetería. el día ${day}/${month} a las ${time} tenemos turno turno en la pelu
\n\n 📍 La dirección es 59 #993 casi esquina 15 (espacio de OtraCasaclub). 
    \n 〰️ la Coquetería está en el piso de arriba. si tenes dificultades para subir escaleras ¡avisanos! que nos adaptamos a tu situación
    \n 👉🏻 por fi, venir con pelo limpio y sin productos de finalizar (cremas de peinar o geles). en caso de solicitar algún servicio con lavado de cabello, esto no es necesario!
    \n ⏰ tratar de ser puntual asi no hacemos esperar a los siguientes clientes. en caso de demora, la tolerancia es de maximo 10 minutos.
    \n 〰️ si venis en auto, considera el tiempo de estacionamiento! es una zona con poca disponibilidad 
    \n 👉🏻 SEÑA: en caso de no poder asistir, avisando con mas de 24 hs se reprograma o devuelve la seña. con menos de ese tiempo, se pierde el monto y la posibilidad de programar de nuevo el turno.
    \n 〰️ la validez de la seña o la devolución de la misma, corre para dentro del mismo mes. pasados los 30 dias, se pierde la posibilidad de contar con ese monto para la reprogramacion del turno. 
    \n ➖no avisando o cancelando una hora antes del encuentro, se deberá abonar el valor completo del turno.
    \n  🤩 en el espacio de @otracasa_ contamos con feria de ropa y emprendimientos. su horario de atencion es de 16 a 20hs. veni a conocerla! 
    \n Cualquier duda o consulta, dejarla por escrito que te contestaré a la brevedad. 
    \n\n ☺️ muchas gracias, te espero!
    \n Valu de @lacoque.teria 🙋🏼‍♀️`: null
    
    const encodedMessageLocal = encodeURIComponent(mensajeLocal);
    const fullUrlLocal = `${baseUrl}${phoneNumber}&text=${encodedMessageLocal}`;
    
    
    
    return (
        <div className='ArrivalsItem '>
            <p className='ArrivalsName'>{client.name}</p>

            <p className='dateTextDash'>
            <strong> {item.toUpperCase()} </strong>  
            </p>

            <p className='dateTextDash '>
             FECHA: <strong>  {day}/{month}/{year}</strong>
            </p>

            <p className='dateTextDash '>
        <strong> {time}</strong>
            </p>


            <p className='dateTextDash'>
              {service === "local" || service === "color" ? "COQUESTUDIO" : "DOMICILIO"}
            </p>

   

            {status === true ? <></> : <p className='nonewdatamini'> Cancelada</p>}

            <div className='ArrivalsButtonsCont'>
                <button className='actionButton' onClick={() => window.location = `mailto: ${client.email}`}>
                    <img className='actionImg' src="https://img.icons8.com/ios-filled/100/000000/new-post.png" />
                </button>



                <button className='actionButton'  onClick={() => window.location = service === "local" || service === "color" ? `${fullUrlLocal}`:  `${fullUrlDom}` }>
                    <img className='actionImg' src="https://img.icons8.com/ios-glyphs/240/000000/whatsapp.png" />
                </button>

                <button className='actionButton' onClick={() => window.location = `tel:${Number(client.phone)}`}>
                    <img className='actionImg' src="https://img.icons8.com/ios-glyphs/90/000000/phone-disconnected.png" />
                </button>
            </div>
        </div>

    )
}
